import { render, staticRenderFns } from "./specialPriceDialog.vue?vue&type=template&id=4d98be32&scoped=true"
import script from "./specialPriceDialog.vue?vue&type=script&lang=js"
export * from "./specialPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98be32",
  null
  
)

export default component.exports